module.exports = __webpack_public_path__ + "static/gatsby-fa5d34fd46acc2d4af2f8dfceca579b3.png";